// import React from 'react';
import { styled } from '@mui/material/styles';
import { IllegalLoggingGoodsClobDto } from 'models/dtoTypes';
import SubSection from './_subSection';
import SdgScoreClob, { ISdgData } from './_sdgScoreClob';
import Empty from './_empty';
import { illegalLogging } from 'kosmos/images';
import EsgLegand from './_esgLegand';
import { useTranslation } from 'react-i18next';

const PREFIX = '_illegalLoggingReport';

const classes = {
  report: `${PREFIX}-report`,
};

const Root = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  [`& .${classes.report}`]: {},
}));

interface IProps {
  name?: string;
  illegalLoggingReport: IllegalLoggingGoodsClobDto[];
}

export default function IllegalLoggingGoodsReport(props: IProps): JSX.Element {
  const { t } = useTranslation('default');
  const { name = t('illegal-logging-check'), illegalLoggingReport } = props;

  const renderSingleClob = (item: IllegalLoggingGoodsClobDto, index: number) => {
    const { entitySummaryCode, entitySummaryDetail, affinity } = item;
    const code: string = entitySummaryCode || t('unknown');
    const desc: string = entitySummaryDetail || t('unknown');
    const title = `${code} - ${desc}`;

    return (
      <SdgScoreClob withBorder={true} withBg={true} key={index} title={title} affinity={affinity} />
    );
  };

  const renderLegands = () => {
    const legands: ISdgData[] = [
      {
        affinity: 'negative',
        title: t(
          'business-products-or-services-associated-with-an-elevated-risk-of-illegal-logging',
        ),
        withBg: true,
        size: 'small',
      },
      {
        affinity: 'warning',
        title: t(
          'business-products-or-services-potentially-associated-with-an-elevated-risk-of-illegal-logging',
        ),
        withBg: true,
        size: 'small',
      },
    ];

    return (
      <EsgLegand
        legands={legands}
        title={t('activity-check-against-illegal-logging')}
        learnMoreTabId="illegal-logging-check"
      />
    );
  };

  const renderContent = () => {
    if (illegalLoggingReport.length === 0) {
      return <Empty title={t('no-exposure-to-illegal-logging-identified')} />;
    }

    return <Root>{illegalLoggingReport.map(renderSingleClob)}</Root>;
  };

  return (
    <SubSection title={name} isBold icon={<img src={illegalLogging} />}>
      <>
        {renderLegands()}
        {renderContent()}
      </>
    </SubSection>
  );
}
